import { Fragment } from 'react';

import { LayoutChooserProps } from './types';

function noLayout(node: React.ReactNode) {
  return node;
}

/**
 * LayoutChooser is intended to add possibility to have nested layouts.
 * With the help of it, you can share layout parts between pages and have different layouts at the same time.
 *
 * Have a look at {@link https://adamwathan.me/2019/10/17/persistent-layout-patterns-in-nextjs/ Persistent Layouts in Next.js}.
 */
export default function LayoutChooser({
  children,
  renderLayout,
  pageProps,
  keyId,
}: React.PropsWithChildren<LayoutChooserProps>) {
  const getLayout = renderLayout || noLayout;

  return <Fragment key={keyId}>{getLayout(children, pageProps)}</Fragment>;
}
